import { Button } from '@/ui/rapid-ui'
import { AlertCircleIcon, Loader2Icon, RefreshCwIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ProvisioningFailedCard({
	provisioningError,
	onRetry,
	isRetrying,
	onDisconnect,
	isDisconnecting,
	retryUnavailable = false,
}: {
	provisioningError: string | null
	onRetry: () => void
	isRetrying: boolean
	onDisconnect: () => void
	isDisconnecting: boolean
	retryUnavailable?: boolean
}) {
	const { t } = useTranslation('common')

	return (
		<div role="alert" className="bg-red-50 border border-red-200 rounded-xl p-5">
			<div className="flex items-start gap-4">
				<div className="size-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
					<AlertCircleIcon className="size-5 text-red-600" />
				</div>
				<div className="flex-1">
					<h3 className="font-medium text-red-900 mb-1">Phone number setup failed</h3>
					{provisioningError && <p className="text-sm text-red-700 mb-3">{provisioningError}</p>}
					<p className="text-sm text-red-600 mb-3">
						{retryUnavailable
							? t('whatsappSettings.activate.temporarilyUnavailable')
							: 'You can retry the setup process. If the problem persists, please contact support.'}
					</p>
					<div className="flex items-center gap-3">
						<Button
							type="subtle"
							onClick={onRetry}
							disabled={retryUnavailable || isRetrying || isDisconnecting}
						>
							{isRetrying
								? (
									<span className="flex items-center gap-2">
										<Loader2Icon className="size-4 animate-spin" />
										Retrying...
									</span>
								)
								: (
									<span className="flex items-center gap-2">
										<RefreshCwIcon className="size-4" />
										Retry setup
									</span>
								)}
						</Button>
						<Button
							type="subtle"
							onClick={onDisconnect}
							disabled={isRetrying || isDisconnecting}
						>
							{isDisconnecting
								? (
									<span className="flex items-center gap-2">
										<Loader2Icon className="size-4 animate-spin" />
										Disconnecting...
									</span>
								)
								: 'Disconnect'}
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}
